(() => {
'use strict';
// NAKED EU: one moving card per row, two static cards between moving cards.
// The selection uses the visible grid, including after filters and resizing.
function selectSpacedVideoCards(cards) {
  const selected = [];
  let lastIndex = -Infinity;
  let lastRow = -Infinity;
  let lastCard = null;
  let row = -1;
  let rowTop = -Infinity;
  cards.forEach((card, index) => {
    if (Math.abs(card.top - rowTop) > 8) { row++; rowTop = card.top; }
    if (!card.hasVideo || index - lastIndex < 3 || row === lastRow) return;
    // Also avoid videos immediately above/below each other in adjacent rows.
    if (lastCard && row === lastRow + 1 && card.left < lastCard.right - 8 && card.right > lastCard.left + 8) return;
    selected.push(card.wrapper);
    lastIndex = index;
    lastRow = row;
    lastCard = card;
  });
  return selected;
}

function createNakedVideoController() {
  const observed = new Set();
  const inView = new WeakMap();
  const pending = new WeakSet();
  const failed = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let allowed = new Set();
  let frame = 0;

  function canPlay(wrapper) {
    return wrapper.isConnected && allowed.has(wrapper) && inView.get(wrapper) &&
      !document.hidden && !reducedMotion.matches && !failed.has(wrapper) &&
      !!wrapper.closest('.image-slide.active');
  }
  function stop(wrapper) {
    const video = wrapper.querySelector('.product-card-video');
    if (video && !video.paused) video.pause();
    if (wrapper.dataset.videoState !== 'idle') wrapper.dataset.videoState = 'idle';
  }
  function sync(wrapper) {
    const video = wrapper.querySelector('.product-card-video');
    if (!video) return;
    if (!canPlay(wrapper)) { stop(wrapper); return; }
    if (!video.paused || pending.has(wrapper)) return;
    pending.add(wrapper);
    wrapper.dataset.videoState = 'loading';
    video.play().then(() => {
      if (canPlay(wrapper)) wrapper.dataset.videoState = 'playing';
      else stop(wrapper);
    }).catch(error => {
      if (error.name !== 'AbortError') failed.add(wrapper);
      stop(wrapper);
    }).finally(() => {
      pending.delete(wrapper);
      // A rapid filter/scroll can cancel a pending play and make it eligible again.
      if (canPlay(wrapper) && video.paused) schedule();
    });
  }
  const intersection = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      inView.set(entry.target, entry.isIntersecting && entry.intersectionRatio >= 0.4);
      sync(entry.target);
    });
  }, { threshold: [0, 0.4], rootMargin: '0px' }) : null;

  function refresh() {
    frame = 0;
    const groups = new Map();
    document.querySelectorAll('product-card').forEach(card => {
      const wrapper = card.querySelector('.video-wrapper');
      if (wrapper && !observed.has(wrapper)) {
        observed.add(wrapper);
        intersection?.observe(wrapper);
        const video = wrapper.querySelector('.product-card-video');
        video?.addEventListener('error', () => { failed.add(wrapper); stop(wrapper); });
      }
      const rect = card.getBoundingClientRect();
      if (!rect.width || !rect.height || getComputedStyle(card).visibility === 'hidden') return;
      const group = card.closest('product-list') || card.closest('.shopify-section') || document.body;
      if (!groups.has(group)) groups.set(group, []);
      groups.get(group).push({ wrapper, hasVideo: !!wrapper, top: rect.top, left: rect.left, right: rect.right });
    });
    allowed = new Set();
    if (!reducedMotion.matches) groups.forEach(cards => {
      selectSpacedVideoCards(cards).forEach(wrapper => allowed.add(wrapper));
    });
    observed.forEach(wrapper => {
      if (!wrapper.isConnected) {
        stop(wrapper);
        intersection?.unobserve(wrapper);
        observed.delete(wrapper);
        return;
      }
      wrapper.dataset.videoSpacing = allowed.has(wrapper) ? 'eligible' : 'static';
      sync(wrapper);
    });
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(refresh);
  }
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('visibilitychange', schedule);
  document.addEventListener('facets:updated', schedule);
  document.addEventListener('shopify:section:load', schedule);
  reducedMotion.addEventListener('change', schedule);
  new MutationObserver(mutations => {
    if (mutations.some(m => m.type === 'childList' ||
      (m.target.matches?.('product-card, product-list, .image-slide') ||
       m.target.querySelector?.('product-card')))) schedule();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
  return { refresh: schedule };
}


document.addEventListener('DOMContentLoaded', function() {
  
  const motionController = createNakedVideoController();
  function initVideoIntersectionObserver() { motionController.refresh(); }

  // ============================================================================
  // NAVIGATION D'IMAGES
  // ============================================================================
  function initProductImageNavigation() {
    const productCards = document.querySelectorAll('product-card');
    
    productCards.forEach(card => {
      if (card.dataset.navInitialized) return;
      card.dataset.navInitialized = 'true';
      
      const container = card.querySelector('.product-media-container');
      if (!container) return;
      
      const totalImages = parseInt(container.dataset.productImages) || 0;
      if (totalImages <= 1) return;
      
      const slides = container.querySelectorAll('.image-slide');
      const leftZone = container.querySelector('.nav-zone--left');
      const rightZone = container.querySelector('.nav-zone--right');
      const centerZone = container.querySelector('.center-click-zone');
      
      if (slides.length <= 1) return;
      
      let currentIndex = 0;
      let isAnimating = false;
      
      function showImage(index) {
        if (index === currentIndex || isAnimating) return;
        
        isAnimating = true;
        
        slides.forEach((slide, i) => {
          slide.classList.toggle('active', i === index);
        });
        
        currentIndex = index;
        
        const videoWrapper = slides[0].querySelector('.video-wrapper');
        if (videoWrapper && index !== 0) {
          const video = videoWrapper.querySelector('.product-card-video');
          if (video && !video.paused) {
            video.pause();
          }
        }
        
        setTimeout(() => {
          isAnimating = false;
        }, 300);
      }
      
      if (leftZone) {
        leftZone.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const newIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
          showImage(newIndex);
        });
      }
      
      if (rightZone) {
        rightZone.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const newIndex = currentIndex === slides.length - 1 ? 0 : currentIndex + 1;
          showImage(newIndex);
        });
      }
      
      if (centerZone) {
        centerZone.addEventListener('click', function(e) {
          e.preventDefault();
          const activeSlide = slides[currentIndex];
          const link = activeSlide ? activeSlide.querySelector('.image-link, .video-link') : null;
          if (link) {
            window.location.href = link.href;
          }
        });
      }
    });
  }
  
  // ============================================================================
  // INITIALISATION
  // ============================================================================
  function init() {
    initProductImageNavigation();
    initVideoIntersectionObserver();
    
    const videosActive = document.querySelectorAll('.product-media-container[data-has-video="true"]').length;
    console.log(`📊 ${videosActive} vidéos activées sur cette page`);
  }
  
  init();
  
  document.addEventListener('facets:updated', () => {
    setTimeout(init, 500);
  });
  
  if (window.MutationObserver) {
    const observer = new MutationObserver(mutations => {
      let hasNewCards = false;
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && (node.matches('product-card') || node.querySelector('product-card'))) {
            hasNewCards = true;
          }
        });
      });
      if (hasNewCards) setTimeout(init, 100);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});

})();
